// src/App.js
import React, { useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import './App.css';
// import { trackPageView, trackUserJourney, setAnalyticsUserId } from './services/analytics';
import { useUser } from './context/UserContext';
// import withAnalytics from './components/analytics/withAnalytics';
import { BioDataProvider } from './context/BioDataContext';
import { SettingsProvider } from './context/SettingsContext';
import { ScenarioProvider } from './context/ScenarioContext';
import { CalculationProvider } from './context/CalculationContext';
import { UserProvider } from './context/UserContext'; // Added UserProvider
import { FeedbackProvider } from './context/FeedbackContext';
import BioInformationForm from './components/bio/BioInformationForm';
import ScenarioList from './components/scenarios/ScenarioList';
import OtherIncomeSection from './components/income/OtherIncomeSection';
import ResultsSection from './components/results/ResultsSection';
import TablesSection from './components/tables/TablesSection';
import AdvancedSettingsSection from './components/settings/AdvancedSettingsSection';
import LandingPage from './components/landing/LandingPage';
import MainLayout from './components/MainLayout';
import FeedbackButton from './components/feedback/FeedbackButton';
import ExitIntentModal from './components/feedback/ExitIntentModal';

// AdminDashboard moved to separate admin app

// import PageFeedbackWidget from './components/feedback/PageFeedbackWidget'; // Removed - redundant with FeedbackButton
// import PerformanceTracker from './components/analytics/PerformanceTracker';

// Component to track route changes
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // trackPageView(location.pathname, {
    //   route: location.pathname,
    //   search: location.search
    // });
  }, [location]);
  
  return null;
};

// The main calculator application component
const CalculatorApp = () => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const { user } = useUser();
  
  // Auto-save functionality is handled in MainLayout component

  // Track user login and set analytics user ID
  useEffect(() => {
    if (user) {
      // setAnalyticsUserId(user.uid);
      // trackUserJourney('user_authenticated', {
      //   user_type: user.isAnonymous ? 'anonymous' : 'registered',
      //   auth_method: user.providerData?.[0]?.providerId || 'unknown'
      // });
    }
  }, [user]);

  // Section names in order for navigation
  const sectionNames = useMemo(() => [
    "Biographic Data",
    "Scenarios",
    "Other Income",
    "Projections",
    "Tables",
    "Advanced Settings"
  ], []);

  // Track section navigation
  useEffect(() => {
      // trackUserJourney('section_viewed', {
    //   section_index: selectedIndex,
    //   section_name: sectionNames[selectedIndex]
    // });
  }, [selectedIndex, sectionNames]);

  // Handler to go to the next section
  const handleNextSection = () => {
    setSelectedIndex((prev) => Math.min(prev + 1, 5)); // 5 = last index (Advanced Settings)
  };

  // Handler to go to the previous section
  const handlePreviousSection = () => {
    setSelectedIndex((prev) => Math.max(prev - 1, 0)); // 0 = first index (Bio)
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {/* Header is now managed by MainLayout */}
      {/* <PerformanceTracker> */}
        <FeedbackProvider>
          <BioDataProvider>
            <SettingsProvider>
              <ScenarioProvider>
                <CalculationProvider>
                <MainLayout 
                  selectedIndex={selectedIndex} 
                  setSelectedIndex={setSelectedIndex}
                >
                <BioInformationForm 
                  onNextSection={handleNextSection} 
                  onPreviousSection={handlePreviousSection}
                  currentSectionIndex={0}
                  sectionNames={sectionNames}
                />
                <ScenarioList 
                  onNextSection={handleNextSection} 
                  onPreviousSection={handlePreviousSection}
                  currentSectionIndex={1}
                  sectionNames={sectionNames}
                />
                <OtherIncomeSection 
                  onNextSection={handleNextSection} 
                  onPreviousSection={handlePreviousSection}
                  currentSectionIndex={2}
                  sectionNames={sectionNames}
                />
                <ResultsSection 
                  onNextSection={handleNextSection} 
                  onPreviousSection={handlePreviousSection}
                  currentSectionIndex={3}
                  sectionNames={sectionNames}
                />
                {/* Tables Section */}
                <TablesSection 
                  onNextSection={handleNextSection} 
                  onPreviousSection={handlePreviousSection}
                  currentSectionIndex={4}
                  sectionNames={sectionNames}
                />
                {/* Advanced Settings Section - Contains Social Security and Global Settings */}
                <AdvancedSettingsSection 
                  onNextSection={handleNextSection} 
                  onPreviousSection={handlePreviousSection}
                  currentSectionIndex={5}
                  sectionNames={sectionNames}
                />
                </MainLayout>
                
                {/* Feedback Components */}
                <FeedbackButton />
                <ExitIntentModal enabled={true} />
                {/* PageFeedbackWidget removed - redundant with FeedbackButton */}
                </CalculationProvider>
              </ScenarioProvider>
            </SettingsProvider>
          </BioDataProvider>
        </FeedbackProvider>
      {/* </PerformanceTracker> */}
    </LocalizationProvider>
  );
};

// Wrap main components with analytics - TEMPORARILY DISABLED
// const AnalyticsLandingPage = withAnalytics(LandingPage, 'landing', {
//   trackClicks: true,
//   trackScrolls: true
// });

// const AnalyticsCalculatorApp = withAnalytics(CalculatorApp, 'calculator', {
//   trackClicks: true,
//   trackScrolls: false // Disable scroll tracking for calculator to avoid noise
// });

// Use unwrapped components temporarily
const AnalyticsLandingPage = LandingPage;
const AnalyticsCalculatorApp = CalculatorApp;

function App() {
  return (
    <UserProvider>
      <Router>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<AnalyticsLandingPage />} />
          <Route path="/app" element={<AnalyticsCalculatorApp />} />
          {/* Admin route moved to separate admin app */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;